<template>
  <span>
    <span class="link" @click="visible = true">
      <span>更多</span>
      <a-icon type="right" />
    </span>

    <Modal v-if="visible" v-model="visible"
           :visible="visible"
           title="告警列表"
           :showFooter="false"
           :overlayOpacity="0.5"
           @update:visible="visible = $event">
      <a-form-model layout="inline" @keyup.enter.native="query" style="margin-bottom: 2vh">
        <a-form-model-item style="width:10%">
          <InputField labelWidth="0" type="text" id="code" v-model="form.code" placeholder="设备编号"/>
        </a-form-model-item>

        <a-form-model-item style="width:10%">
          <InputField labelWidth="0" type="text" id="name" v-model="form.name" placeholder="设备名称"/>
        </a-form-model-item>

        <a-form-model-item>
          <SelectField labelWidth="0" :options="typeList" v-model="form.type" id="type" placeholder="设备类型"/>
        </a-form-model-item>

        <a-form-model-item>
            <SelectField labelWidth="0" :options="alertCategoryList" v-model="form.category" id="category" placeholder="告警分类"/>
        </a-form-model-item>

        <a-form-model-item style="width:20%">
            <RangePickerField labelWidth="0" v-model="form.date" :placeholder="['开始时间', '结束时间']" :disabled="false"/>
        </a-form-model-item>
        <a-form-model-item>
          <a-space>
            <ButtonField text="查询" @click="query" secondary />
            <ButtonField text="重置" primary @click="reset"/>
          </a-space>
        </a-form-model-item>
      </a-form-model>
      <Tablelist
              :showCheckbox="false"
              :list="list"
              :columns="tableColumns"
      />
    </Modal>
  </span>
</template>

<script >
import { fetchAlertList } from "@/api/alert";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      visible: false,
      form: {},
      list: [],
      loading: false,
      total: 0,
      current: 1,
      pageSize: 10,
      tableColumns: [
          {
              key: 'code',
              title: '设备编号',
              field: 'code',
              infotype: 'text'
          },
          {
              key: 'name',
              title: '设备名称',
              field: 'name',
              infotype: 'text',
          },
          {
              key: 'type',
              title: '设备类型',
              field: 'type',
              infotype: 'dictType',
              dictType: 'deviceType'
          },
          {
              key: 'remark',
              title: '告警内容',
              field: 'remark',
              infotype: 'text',
          },
          {
              key: 'alertTime',
              title: '告警时间',
              field: 'alertTime',
              infotype: 'text',
          },
          {
              key: 'actions',
              title: '操作',
              infotype: 'template',
          }

      ],
    };
  },

  computed: {
    ...mapGetters("setting", ["findDataDict"]),

    typeList() {
      return this.findDataDict("deviceType");
    },

    alertCategoryList() {
      return this.findDataDict("alertCategory");
    },
  },
  watch: {
    visible() {
      if (this.visible) {
        if (this.list.length === 0) {
          this.query();
        }
      }
    },
  },

  methods: {
    getList() {
      this.loading = true;
      let { current, pageSize, form } = this;

      let startDate, endDate;
      if (Array.isArray(form.date) && form.date.length === 2) {
        startDate = form.date[0].format("YYYY-MM-DD");
        endDate = form.date[1].format("YYYY-MM-DD");
      }

      fetchAlertList({
        pageNum: current,
        pageSize,
        ...form,
        startDate,
        endDate,
        date: undefined,
      })
        .then((res) => {
          this.loading = false;
          if (Array.isArray(res.list)) {
            this.list = res.list;
            this.total = res.totalSize || 0;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList();
    },
    reset() {
      this.form = {};
      this.current = 1;
      this.getList();
    },
    query() {
      this.current = 1;
      this.getList();
    },
    cancel() {
      this.visible = false;
    },

    openLocation(text) {
      this.cancel();
      this.$emit("select", {
        ...text,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.link {
  font-size: 0.8em;
  font-weight: normal;
  display: flex;
  align-items: center;
}
</style>